import { api } from "./api"

export const GET_ALL_HOLIDAYS = async () => {
    const {data} = await api.get(`/holidays/all`)
    return data;
}

export const DELETE_HOLIDAY = async (holidayId) => {
    const {data} = await api.delete(`/holidays/${holidayId}`)
    return data;
}

export const SAVE_HOLIDAY = async (params) => {
    const {data} = await api.post(`/holidays/save`, params)
    return data;
}
